import * as actions from "./actions";

let initialState = {
  sending: false,
  sent: false,
  sentError: null,
};

const organisations = (state = initialState, action) => {
  switch (action.type) {
    case actions.ORGANISATION_ADD_REQUEST:
      return Object.assign({}, state, {
        sending: true,
        sentError: null,
      });
    case actions.ORGANISATION_ADD_SUCCESS:
      return Object.assign({}, state, {
        sending: false,
        sent: true,
      });
    case actions.ORGANISATION_ADD_ERROR:
      return Object.assign({}, state, {
        sending: false,
        sentError: action.error,
      });
    default:
      return state;
  }
};

export default organisations;
